import {app} from "@/app";
import {AbstractShopifyEvent, EventData} from "@/services/pixel/events/shopify/AbstractShopifyEvent";
import {merge} from "@/helpers";

export class AddShippingInfo extends AbstractShopifyEvent {

  async handle(eventPayload: null|Record<any, any> = null, eventContext: null|Record<any, any> = null) {
    await super.handle(eventPayload, eventContext);

    app.debug('Pixel: Shopify Event AddShippingInfo: started');
    app.pixel.log.add({type: 'event.shopify', name: 'AddShippingInfo'});

    const payload = merge({
      cart: app.storage.shopify.cart.payload,
    }, eventPayload ?? {});

    let context = await this.getEventContext();
    context = merge(context, eventContext ?? {});

    // send
    const data: EventData = {
      event_name: 'AddShippingInfo',
      event_version: 4,
      payload,
      context,
    };

    await this.pushEventAndSendStack(data);
  }

}
